import { useEffect } from 'react';
import { markIntentionalEmptyTasksSave } from '../../../../utils/allowEmptyTasksSave';

/** Delete and Backspace remove the selection, matching the flow view. */
export function useBoardDelete({ tasksRef, selectedRef, onSelectionChangeRef, flowRef }) {
  useEffect(() => {
    const onKey = (event) => {
      const target = event.target;
      if (target?.tagName === 'INPUT' || target?.tagName === 'TEXTAREA' || target?.isContentEditable) return;
      if (event.key !== 'Delete' && event.key !== 'Backspace') return;
      const selected = selectedRef.current;
      if (!selected || selected.size === 0) return;
      event.preventDefault();
      const ids = Array.from(selected);
      const allTasks = tasksRef.current || [];
      const clearAndDelete = () => {
        flowRef.current?.onDeleteTasks?.(ids);
        onSelectionChangeRef.current?.(new Set());
      };
      const isDeleteAll = allTasks.length > 0 && selected.size === allTasks.length;
      if (isDeleteAll) {
        const campaignId = flowRef.current?.campaignId;
        window.dispatchEvent(new CustomEvent('fokus:requestDeleteAllTasks', {
          detail: {
            campaignId,
            campaignName: flowRef.current?.sprintName || 'this campaign',
            taskCount: allTasks.length,
            onConfirm: () => {
              markIntentionalEmptyTasksSave(campaignId);
              clearAndDelete();
            },
          },
        }));
        return;
      }
      clearAndDelete();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [tasksRef, selectedRef, onSelectionChangeRef, flowRef]);
}
